export interface RuntimeConfig {
  apiUrl: string;
  supabaseUrl: string | null;
  supabasePublishableKey: string | null;
  demoMode: boolean;
  environment: "local" | "staging" | "production";
}

function optional(value: string | undefined): string | null {
  const normalized = value?.trim();
  return normalized ? normalized.replace(/\/$/, "") : null;
}

export function getRuntimeConfig(): RuntimeConfig {
  return {
    apiUrl: optional(import.meta.env.VITE_KITCHEN_HUB_API_URL) ?? window.location.origin,
    supabaseUrl: optional(import.meta.env.VITE_SUPABASE_URL),
    supabasePublishableKey: optional(import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY),
    demoMode: import.meta.env.VITE_KITCHEN_HUB_DEMO_MODE === "true",
    environment: import.meta.env.VITE_KITCHEN_HUB_ENVIRONMENT === "staging" ? "staging" : import.meta.env.VITE_KITCHEN_HUB_ENVIRONMENT === "production" ? "production" : "local",
  };
}
